export const dataMenu = [
  {
    title: "Serwis opon",
    slug: "/serwis-opon",
    highlighted: true,
  },
  // {
  //   title: "DETAILING & WRAPPING",
  //   slug: "/auto-detailing-car-wrapping",
  // },
  {
    title: "O nas",
    slug: "/o-nas",
    highlighted: false,
  },
  {
    title: "usługi i cennik",
    slug: "/uslugi-i-cennik",
    highlighted: false,
  },
  {
    title: "nasze lokalizacje",
    slug: "/nasze-lokalizacje",
    highlighted: false,
  },
  {
    title: "Strefa wiedzy",
    slug: "/strefa-wiedzy",
    highlighted: false,
  },
  {
    title: "kontakt",
    slug: "/kontakt",
    highlighted: false,
  },
];
